function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessAndTrade2891415(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14 9.09 8.81 1.75c.71.15 1.19.75 1.19 1.46v10.2c0 .83-.67 1.5-1.5 1.5h-9c.28 0 .5-.22.5-.5v-.5h8.5c.27 0 .5-.22.5-.5v-10.2c0-.23-.16-.44-.39-.49l-8.61-1.7z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5 14c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5 17c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5 20c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 23.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-.5-13.5c0-.15.07-.29.18-.39.12-.09.27-.13.42-.1l.4.08v1.02 12.89z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 23v.5c0 .28.22.5.5.5h-4c.28 0 .5-.22.5-.5v-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 5c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 8.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2c.28 0 .5.22.5.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 11c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 14c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 14.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2c.28 0 .5.22.5.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 5c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 8c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 11c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 18.5c0-.28-.23-.5-.5-.5h-3c-.28 0-.5.22-.5.5v4.5h-1v-4.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v4.5h-1z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 23h4 1v.5c0 .28-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5v-.5z",
    style: {},
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.75.2 10.99 1.67c.73.12 1.26.74 1.26 1.48v5.74l-.4-.08c-.15-.03-.3.01-.42.1-.11.1-.18.24-.18.39v-6.15c0-.25-.18-.46-.42-.5l-10.99-1.66c-.03-.01-.06-.01-.09-.01-.12 0-.23.04-.32.12-.12.1-.18.23-.18.38v20.82c0 .28.23.5.5.5h2.5v.5c0 .28.22.5.5.5h-3c-.83 0-1.5-.67-1.5-1.5v-20.82c0-.44.19-.86.53-1.14.34-.29.78-.41 1.22-.34z",
    style: {},
    "data-original": "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessAndTrade2891415);
export default __webpack_public_path__ + "static/media/business-and-trade_2891415.88ba517dbaced68824afad881c0ddae7.svg";
export { ForwardRef as ReactComponent };